import { LangEnum } from '@enums';
import { SnackNotification } from '@types';

export type AppState = {
  ready: boolean;
  isFailure: boolean;
  lang: LangEnum;
  isLangDisabled: boolean;
  loading: boolean;
  notification: SnackNotification;
  registeredRoute: string;
  barLoading: boolean;
  backdropLoading: boolean;
};

export const appInitialState: AppState = {
  ready: false,
  isFailure: false,
  lang: LangEnum.ENG,
  isLangDisabled: false,
  loading: true,
  notification: null,
  registeredRoute: null,
  backdropLoading: false,
  barLoading: false,
};
